import type {ProcessAttributeTemplate} from "../../types";

export const PROCESS_ATTRIBUTE_TEMPLATE: ProcessAttributeTemplate[] = [
  {key: "process_owner", title: "Process Owner", kind: "Text", placeholder: "e.g. VP of Finance"},
  {key: "key_participants", title: "Key Participants", kind: "Text", placeholder: "e.g. AP Team, Treasury, Controller"},
  {
    key: "frequency",
    title: "Frequency",
    kind: "SingleSelect",
    options: ["Continuous", "Daily", "Weekly", "Monthly", "Quarterly", "Annually", "Ad hoc"],
  },
  {
    key: "process_type",
    title: "Process Type",
    kind: "SingleSelect",
    options: ["Manual", "Automated", "IT-dependent manual", "Hybrid"],
  },
  {
    key: "materiality",
    title: "Materiality",
    kind: "SingleSelect",
    options: ["Material", "Significant", "Non-significant"],
  },
  {key: "transaction_volume", title: "Est. Annual Transaction Volume", kind: "Number", placeholder: "e.g. 50000"},
];

// Default attribute values per process
export const PROCESS_ATTRIBUTE_VALUES: Record<string, Record<string, string>> = {
  "proc-vendor-invoice": {
    process_owner: "VP of Finance",
    frequency: "Continuous",
    process_type: "IT-dependent manual",
    materiality: "Material",
    transaction_volume: "85000",
  },
  "proc-expense-reimbursement": {
    process_owner: "Controller",
    key_participants: "Employee, Approving Manager, Expense Administrator, Accounts Payable, Internal Audit",
    frequency: "Continuous",
    process_type: "IT-dependent manual",
    materiality: "Significant",
    transaction_volume: "12000",
  },
  "proc-corp-card": {
    process_owner: "Treasury Manager",
    key_participants: "Cardholder, Approving Manager, Card Administrator, Accounts Payable, Treasury",
    frequency: "Monthly",
    process_type: "Hybrid",
    materiality: "Significant",
    transaction_volume: "4500",
  },
  "proc-order-fulfillment": {
    process_owner: "VP of Revenue Operations",
    frequency: "Continuous",
    process_type: "Automated",
    materiality: "Material",
    transaction_volume: "120000",
  },
  "proc-contract-rev-rec": {
    process_owner: "Chief Accounting Officer",
    key_participants: "Sales/Deal Desk, Revenue Accounting, Revenue Recognition Committee, Controller, External Audit",
    frequency: "Monthly",
    process_type: "IT-dependent manual",
    materiality: "Material",
    transaction_volume: "2400",
  },
  "proc-credit-collections": {
    process_owner: "Credit Manager",
    key_participants: "Sales Team, Credit Manager, AR Analyst, Collections Specialist, Controller",
    frequency: "Weekly",
    process_type: "Hybrid",
    materiality: "Significant",
    transaction_volume: "8000",
  },
  "proc-journal-entry": {
    process_owner: "Controller",
    key_participants: "Staff Accountant, Accounting Manager, Controller, Financial Reporting",
    frequency: "Monthly",
    process_type: "IT-dependent manual",
    materiality: "Material",
    transaction_volume: "1500",
  },
  "proc-month-end-close": {
    process_owner: "Accounting Manager",
    key_participants: "Staff Accountant, Accounting Manager, Controller, Financial Reporting, External Audit",
    frequency: "Monthly",
    process_type: "Manual",
    materiality: "Material",
  },
  "proc-intercompany": {
    process_owner: "Group Accounting Manager",
    key_participants: "Entity Controller, Consolidation Accountant, Group Accounting Manager, Treasury, External Audit",
    frequency: "Monthly",
    process_type: "IT-dependent manual",
    materiality: "Significant",
    transaction_volume: "600",
  },
};
